import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as vehicleActions from "../actions/vehicles";


// if (window.navigator && Object.keys(window.navigator).length == 0 && !window.document) {
//   window = Object.assign(window, { navigator: { userAgent: 'ReactNative' } });
// }

// var io = require("socket.io-client/dist/socket.io");
// const apiUrl = 'http://localhost:5000/';

class VehicleSocket extends Component {

  componentDidMount() {

  //   this.socket = io('http://localhost:5000/', {
  //     transports: ['websocket']
  //   });
  // // this.socket =io.connect('http://localhost:5000/' );
  //   this.socket.on('vehicles_update', (data) => {
  //     console.log( "...vehicles_update" );
  //     if (this.props.realtime) {
  //       console.log(this.props.realtime +"..."+ data);
  //       this.props.actions.rtUpdateVehicles(data)
  //     }
  //   });

  }

  componentWillUnmount() {
    //disconnect scoket
  }

  render() {
    return (
      this.props.children
    )
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch, props) => {
  return {
    actions: bindActionCreators(vehicleActions, dispatch)
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(VehicleSocket)
